import React, {Component} from 'react';
import {SortableElement} from 'react-sortable-hoc';
import PropTypes from "prop-types";

class SortableCondition extends Component {
    render(){
            return (
                <div className="panel customPanel">
                    <button className="btn btn-danger btn-delete-rule"
                            onClick={(e) => this.props.removeRule(this.props.number)}
                    ><i className="zmdi zmdi-close" /></button>
                    <div className="panel-body sp-20">
                        <div className="condition_list">
                            {this.props.condition.subjects.map((sub, subIndex) => {
                                let showTieBetween = false;

                                if (subIndex === 0 && sub.condition === "tie") {
                                    showTieBetween = true;
                                } else if (subIndex > 0 && this.props.condition.subjects[subIndex - 1].condition !== "tie") {
                                    showTieBetween = true;
                                }
                                return (
                                    <span className="condition-subject" key={`${this.props.number}-${subIndex}`}>

                                                {showTieBetween &&
                                                <span> Tie between </span>
                                                }

                                        {sub.condition === "score" &&
                                        <span> Score for </span>
                                        }


                                        <select
                                            className=""
                                            value={sub.id || ''}
                                            onChange={(e) => this.props.updateConditionSubject(this.props.number, subIndex, e.target.value)}
                                        >
                                                    <option value="">Choose</option>
                                            {this.props.renderSubjectSelect()}
                                                </select>

                                        {sub.condition === "score" &&
                                        <span>


                                                        <span>
                                                            <button
                                                                href="#"
                                                                className="dropdown-toggle btn btn-transparent"
                                                                data-toggle="dropdown"
                                                                role="button"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"
                                                            >
                                                                {sub.operator || 'select operator'} &nbsp;
                                                            </button>
                                                            <ul className="dropdown-menu condition-dropdown">
                                                                <li>
                                                                    <button onClick={(e) => this.props.setConditionOperator(this.props.number, subIndex, '<')}>
                                                                        LESS THAN
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button onClick={(e) => this.props.setConditionOperator(this.props.number, subIndex, '>')}>
                                                                        MORE THAN
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button onClick={(e) => this.props.setConditionOperator(this.props.number, subIndex, '==')}>
                                                                        EQUAL TO
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </span>

                                            &nbsp;

                                            <input type="number" value={sub.value} onChange={(e) => this.props.setConditionValue(this.props.number, subIndex, e.target.value)} placeholder="Number"/> &nbsp;

                                                    </span>
                                        }

                                        {sub.connector &&
                                        <span>{sub.connector}</span>
                                        }

                                        <span className="delete-condition">
                                                      <button className="btn btn-danger" onClick={(e) => this.props.removeCondition(this.props.number, subIndex)}>Delete</button>
                                                    </span>
                                            </span>
                                )
                            })}

                            <span className="dropdown">
                                    <button
                                        href="#"
                                        className="dropdown-toggle add_rule btn btn-danger"
                                        data-toggle="dropdown"
                                        
                                    >
                                        <i className="zmdi zmdi-plus"/>
                                    </button>
                                    <ul className="dropdown-menu condition-dropdown">
                                        <li>
                                            <button className="btn btn-link btn-light" onClick={(e) => this.props.addCondition(this.props.number, "tie")}>
                                                Tie Condition
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={(e) => this.props.addCondition(this.props.number, "score")}
                                               className={(this.props.onlyShowTie) ? "disabled btn btn-link btn-light" : "btn btn-link btn-light"}

                                            >
                                                Score Condition
                                            </button>
                                        </li>
                                        <li className="menu-title">Operators</li>
                                        <li>
                                            <button onClick={(e) => this.props.setConditionConnector(this.props.number, "and")}
                                                    className={(this.props.onlyShowTie) ? "disabled btn btn-link btn-light" : "btn btn-link btn-light"}

                                            >
                                                AND
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={(e) => this.props.setConditionConnector(this.props.number, "or")}
                                                    className={(this.props.onlyShowTie) ? "disabled btn btn-link btn-light" : "btn btn-link btn-light"}

                                            >
                                                OR
                                            </button>
                                        </li>
                                        <li>
                                            <button onClick={(e) => this.props.setConditionConnector(this.props.number, "then")}
                                                    className={(this.props.onlyShowTie) ? "disabled btn btn-link btn-light" : "btn btn-link btn-light"}

                                            >
                                                THEN
                                            </button>
                                        </li>
                                    </ul>
                                    </span>
                            &nbsp;

                            {this.props.showThen && !this.props.onlyShowTie &&
                            <span>
                                                then &nbsp;
                                <select
                                    className=""
                                    value={this.props.condition.result || ''}
                                    onChange={(e) => this.props.setConditionResult(this.props.number, e.target.value)}
                                >
                                        <option value="">Choose</option>
                                    {this.props.renderSubjectSelect()}
                                    </select>
                                     takes priority
                                            </span>
                            }

                        </div>
                    </div>
                </div>
            )

    }
}

export default SortableElement(SortableCondition);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableCondition.js